import { PAYMENT_MODULE } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { setPaymentModeChange } from "@/app_redux/reducers/slices/auth/inventory_slice";
import { IPaymentModeChangeFilterData, IPaymentModeChangeResponse } from "@/api_framework/api_modals/payment";

AxiosCurlirize(axios, () => {});
type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

export const usePaymentModeChangeAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (filterParams: IPaymentModeChangeFilterData) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: InventoryTaxCreateAPIResponse = await axios
          .post(PAYMENT_MODULE?.PAYMENT_MODE_CHANGE?.baseURL ?? "", filterParams, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IPaymentModeChangeResponse>) => {
            if (res.data.status === true) {
              dispatch(setPaymentModeChange({ data: res.data.data }));
              return { status: true, message: "batch" };
            } else {
              dispatch(setPaymentModeChange({ data: null }));
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            dispatch(setPaymentModeChange({ data: null }));
            return { status: false, message: null };
          });
        return response;
      } catch (e: any) {
        dispatch(setPaymentModeChange({ data: null }));
        // toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute };
};
